import React, { Component, useEffect, useState } from 'react';
import PlaceOrderView from './PlaceOrderView'
import { getOrderCache, order_key, setOrderCache } from '../../utils/order_cache';
import { getAppCfg } from '../../utils/common';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import { formatDateTimeFrEpoch, formatTimeFrEpoch, newGUID } from '../../utils/util';
import crmservices from '../../wsclient/crmservices';
import { useTabContext } from '@material-ui/lab';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import PaymentForm from './PaymentForm';
import MyProfile from '../my-profile/MyProfile';
import OrderResultController from './OrderResultController';
import Loading from '../../components/Loading';
import { portalCfg } from '../../../portal.router.config';
import VNPay from './VNPayInitOrder';
function PlaceOrderController(props) {

    var app_config = getAppCfg();
    const [showLoading, onShowLoading] = useState(false);
    const [deliveredAtOrg, setDeliveredAtOrg] = useState(null);
    const [isEditTime, onEditTime] = useState(false);
    const [estimateTime, setEstimateTime] = useState(null);
    const [waitSelelectTime, setWaitSelectTime] = useState(null);
    const [timeSelected, setTimeSelected] = useState(null);
    const [message, setMessage] = useState({});
    const [showPhoneValidation, onShowPhoneValidation] = useState(null);
    const [active, setActive] = useState('main');
    const [showPaymentForm, onShowPaymentForm]  = useState(false);
    const [paymentFormData, setPaymentFormData] = useState(null);
    const [contact_phone, setContactPhone] = useState(null);
    const [order_result, setOrderResult] = useState(null);
    const [delivered_at, setDeliveryAt] = useState(null);
    const auth_support = app_config.auth_support;
    const order_type = getOrderCache(order_key.order_type, true);
    const [orderSummary, setOrderSummary] = useState({})
    useEffect(()=>{
        loadPhone();
        var estimate_order_result = getOrderCache(order_key.estimate_order_result);

        var estimated_delivery = estimate_order_result&&estimate_order_result.order_estimate && estimate_order_result.order_estimate.estimated_delivery ? estimate_order_result.order_estimate.estimated_delivery : null;
        var deliveredAtOrg = estimated_delivery&&estimated_delivery.delivered_at ? formatDateTimeFrEpoch(estimated_delivery.delivered_at, true) : "";
        //console.log('deliveredAtOrg==',deliveredAtOrg)

        setEstimateTime(estimated_delivery.delivered_at);
        setDeliveredAtOrg(deliveredAtOrg);
    },[]);

    const onChangeTime = async(date) =>{
        //console.log('date======',date)
        onEditTime(false);
        setWaitSelectTime(true);
        try {
            var currentTime = new Date().getTime();
            var timeSelected = new Date(date).getTime();
            var newEstimateTime = estimateTime *1000;
            var requestedTime = timeSelected - currentTime;
            var orderType = getOrderCache(order_key.order_type,true);
            setTimeSelected(timeSelected);
            setDeliveredAtOrg(date);
            if (requestedTime < 0 || timeSelected < newEstimateTime) {
                showMessage(true,orderType=='DELIVERY' ? t('DELIVERY_VALIDATION_TIME') : t('PICK_UP_VALIDATION_TIME'));
            } else {
                
                var requested_delivery_at = {
                    date: (timeSelected / 1000).toFixed(0)
                }
                
                var payload = {
                    supply_method: orderType,
                    requested_delivery_at: requested_delivery_at
                }
                if (orderType === 'DELIVERY') {
                    payload.address_id = getOrderCache(order_key.delivery_address).id;
                } else {
                    payload.lat_lot = getOrderCache(order_key.pick_up_store).address.lat + ":" + getOrderCache(order_key.pick_up_store).address.lon;
                }
               
                var result = await crmservices.orders.orderFulfillment(payload);
                if (result.code === 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
                    showMessage(null);
                    await onEstimateOrder(requested_delivery_at);
                }else if (result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                    showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                } else {

                    showMessage(true,orderType=='DELIVERY' ? t('DELIVERY_VALIDATION_LOCATION') : t('PICK_UP_VALIDATION_LOCATION'))
                }
            }
        } catch (error) {
            console.log("check time error:", error);
            showMessage(true,orderType=='DELIVERY' ? t('DELIVERY_VALIDATION_LOCATION') : t('PICK_UP_VALIDATION_LOCATION'));
        }
        setWaitSelectTime(false);
    }
    const onPlaceOrderProcess = async() =>{
        //console.log('requested_delivery_at===',requested_delivery_at)
        if (contact_phone && contact_phone.number) {
            processOrder();
        } else {
            onShowPhoneValidation(true)
            showMessage(true, t('PHONE_NUMBER_NOT_FOUND'));
        }
    }


    const processOrder = async() =>{
        const {isUseWalletFund, requestAmountFromWalletFunds, setActivePage, paymentMethod, primary_card} = props;
        onShowLoading(true);
        let estimate_order_result = getOrderCache(order_key.estimate_order_result);
        
            
        
        var payload = {
            estimation_id: estimate_order_result.id,
            use_wallet_funds: isUseWalletFund 
        }
        var order_summary = await dataUtil.getOrderSummary(estimate_order_result, payload.use_wallet_funds, requestAmountFromWalletFunds, true)
       // console.log('request_amount_from_wallet_funds===', request_amount_from_wallet_funds)
        if(requestAmountFromWalletFunds!=undefined && payload.use_wallet_funds){
           // console.log('wallet_funds_amount===', request_amount_from_wallet_funds)
            payload.wallet_funds_amount = Number(requestAmountFromWalletFunds)
        }
         //order 3D check
        if (paymentMethod === 'CASH' || !order_summary.amountDue){
            payload.payments = [{ payment_method_type: 'CASH' }]
            if (!order_summary.amountDue){
                payload.payments = [{ payment_method_type: 'CASH', amount : 0 }]
            }
            try {
                var result = await crmservices.orders.makeOrder(payload);
                if (result.code == 'OK') {
                    var orderResult = result.data;
                    var orderDetail = await crmservices.orders.getOrder(result.data.id);
                    if (orderDetail.code === 'OK') {
                        orderResult.key_dates = orderDetail.data.key_dates;
                        orderResult.total_cost = orderDetail.data.total_cost
                    }
                    setOrderCache(order_key.order_status, 'DONE', true)
                    setOrderResult(orderResult);
                    setActive('order_result');
                }  else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED') {
                    showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
                } else {
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
            } catch (error) {
                console.log("make order exception:", error);
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
            //order 3D check
        }
        else if (paymentMethod === 'VNPAY'){
            payload.payments = [{ payment_method_type: 'CASH' }]
            setOrderCache(order_key.cache_order_to_be_process, payload);
            setOrderSummary(order_summary);
            setActive('vnpay');
        }
        else{
            // if(primary_card.payment_method_type === 'TOKEN'){
            //     try{
            //         let token = primary_card.card && primary_card.card.gateway_token && primary_card.card.gateway_token[0].token ? primary_card.card.gateway_token[0].token: null;
            //         if(token){
            //             let body = {
            //                 payment_method_token: token,
            //                 amount: order_summary.amountDue,
            //                 order_id: estimate_order_result.id,
            //             }
            //             let result = await crmservices.paymentgateway.sale(body)
            //             console.log('sale result==', result);
            //             if(result.code === 'OK'){
            //                 payload.payments = [{ 
            //                     payment_method_type: 'TOKEN',
            //                     payment_method_id: primary_card.id,
            //                     payment_token: estimate_order_result.id,
            //                 }];
            //                 await onMakeOrder(payload);
            //             }
            //         }
            //     }
            //     catch(e){
            //         console.log('sale result==', result);
            //     }

            // }
            // else{
                setPaymentFormData(null);
                onShowPaymentForm(false);
                

                payload.payments = [{ 
                    payment_method_type: 'TOKEN',
                    payment_method_id: primary_card.id,
                    payment_token: estimate_order_result.id,
                }];


                var token = newGUID();
                let responseURL = window.location.origin + portalCfg.basename + '/process_order/' + token;

                setOrderCache(order_key.order_token, token);
                var paymentFormResult = await crmservices.orders.createPaymentForm({ estimation_id: estimate_order_result.id, payment_method_id: primary_card.id,redirect_url:responseURL });
                if (paymentFormResult.code == 'OK') {
                    setOrderCache(order_key.cache_order_to_be_process,payload);
                    //console.log("paymentFormResult:",paymentFormResult.data);
                    setPaymentFormData(paymentFormResult.data);
                    onShowPaymentForm(true);
                } else {
                    showMessage(true, t('EXCEPTION_PROCESS'));
               // }
            }
        }
        onShowLoading(false);
    }
    const onMakeOrder = async(payload) =>{
        try {

            var result = await crmservices.orders.makeOrder(payload);
            if (result.code == 'OK') {
                var orderResult = result.data;
                var orderDetail = await crmservices.orders.getOrder(result.data.id);
                if (orderDetail.code === 'OK') {
                    orderResult.key_dates = orderDetail.data.key_dates;
                    orderResult.total_cost = orderDetail.data.total_cost
                }
                setOrderCache(order_key.order_status, 'DONE', true)
                setOrderResult(orderResult);
                setActive('order_result');
            }  else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED') {
                showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
            } else {
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log("make order exception:", error);
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
    }
    const onEstimateOrder = async(requested_delivery_at) =>{
        const { order_notes, isUseWalletFund, requestAmountFromWalletFunds, paymentMethod } = props;
        //console.log('refeshFundWallet====',refeshFundWallet)
        var cart = getOrderCache(order_key.cart);
        const address = getOrderCache(order_key.delivery_address)

        //console.log("onEstimateOrder cart:", cart);
        try {
            var body = {
                supply_method: order_type,
                line_items: dataUtil.getLineItems(cart),
            }
            if(order_type === 'DELIVERY'){
                if (address.id)
                    body.address_id = getOrderCache(order_key.delivery_address).id
                else{
                    body.current_location = {}
                    body.current_location.address_line_1 = address.address_line_1
                    body.current_location.address_line_2 = address.address_line_2
                    body.current_location.state_province_county = address.state_province_county
                    body.current_location.postal_code = address.postal_code
                    body.current_location.country_code = address.country_code
                    body.current_location.lat = address.lat
                    body.current_location.lon = address.lon
                    body.current_location.town_city = address.town_city
                    body.current_location.googlePlaceId = address.googlePlaceId
                }
            }
            if (order_type === 'PICK_UP' || order_type === 'DIRECT_SALE') {
                body.fulfilled_by = getOrderCache(order_key.pick_up_store).id;
            } else {
                body.fulfilled_by = getOrderCache(order_key.delivery_fulfilled_by).id;
            }
            if(order_notes){
                body.notes = order_notes;
            }
            if (requested_delivery_at) {
                body.requested_delivery_at = requested_delivery_at;
            }
            if (isUseWalletFund != undefined){
                body.use_wallet_funds = isUseWalletFund
            }
            if(body.use_wallet_funds && requestAmountFromWalletFunds)
                body.wallet_funds_amount = Number(requestAmountFromWalletFunds);
            


            if(paymentMethod){
                body.payment_method_type = paymentMethod == 'VNPAY' ? 'CASH' : paymentMethod;
            }

            //console.log('onEstimateOrder body=======',body)
            var result = await crmservices.orders.estimateOrder(body);
            var estimate_order_result = {}
            if (result.code === 'OK') {
                estimate_order_result = result.data;
            }else if(result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION'){
                showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'))
            } else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED'){
                showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
            } else if (result.code == 'SERVICE_ALREADY_EXIST') {
                showMessage(true, t('SERVICE_ALREADY_EXIST'));
            } else {
                showMessage(true, t('EXCEPTION_PROCESS'))
            }
            setOrderCache(order_key.estimate_order_result, estimate_order_result);
            return estimate_order_result;
        } catch (error) {
            console.log("On estimate order error:", error);
            showMessage(true, t('EXCEPTION_PROCESS'))
        }
    }

    const loadPhone = async() =>{
        try {
            var phoneResult = await crmservices.contacts.getPhones();
            if (phoneResult.code === 'OK') {
                var content = phoneResult.data.content;
                if (content && content.length > 0) {
                    var phone = content.filter(p => p.is_primary);
                    if (phone && phone.length > 0) {
                        setContactPhone(phone[0])
                    }
                }
            }
        } catch (error) {
            console.log("load phone exception:", error);
        }
    }

    const onGoBackFromProfile = async() =>{
        await loadPhone();
        setActive('main');
    }
    const showMessage = (status, message) =>{
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    return (
        <div>
        {props.open && <PlaceOrderView
            open={props.open}
            onClose={props.onClose}
            currency={props.currency}
            onGoBack={props.setActivePage}
            estimate_order_result={getOrderCache(order_key.estimate_order_result)}
            delivery_address={getOrderCache(order_key.delivery_address)}
            pick_up_store={getOrderCache(order_key.pick_up_store)}
            order_type={getOrderCache(order_key.order_type,true)}
            contact_phone={contact_phone}
            processOrder={onPlaceOrderProcess}
            showPhoneValidation = {showPhoneValidation}
            onGoToProfile={()=>setActive('profile')}
            auth_support={auth_support}
            onEditTime = {onEditTime}
            isEditTime={isEditTime}
            waitSelelectTime={waitSelelectTime}
            onChangeTime={onChangeTime}
            deliveredAtOrg={deliveredAtOrg}
            timeSelected={timeSelected}
        />}
        {showPaymentForm && <PaymentForm
                open={showPaymentForm}
                onClose={()=>onShowPaymentForm(false)}
                paymentFormData={paymentFormData}
                />}
        {active == 'profile' && <MyProfile
                open={active == 'profile'}
                handleDrawerOtherToggle={onGoBackFromProfile}/>}
        {active == 'order_result' && <OrderResultController
                open={active == 'order_result'}
                onClose={()=>props.onClose()}
                order_result={order_result}
            />}
            {active == 'vnpay' && <VNPay
            open={active == 'vnpay'}
            onClose={()=>setActive('main')}
            amount={orderSummary.amountDue}
            />}    
        {message && <ModalAlert
            open={message.show}
            onClose={showMessage}
            message={message.content}
        />}
        {showLoading && <Loading showLoading={showLoading} />}
        </div>
    );
}

export default PlaceOrderController;